<template>
  <Form style="line-height:32px"
        :label-width="120"
        ref="form"
        :model="formData"
        inline>
    <FormItem style="width:90%"
              :label="$t('erp.b2c.search_outwarehouse',{defaultValue:'发货仓库'})"
              prop="orgWarehouseCode">
      <Select v-model="formData.orgWarehouseCode"
              :placeholder="$t('erp.b2c.orgWarehouse_null',{defaultValue:'不选时不做处理'})"
              filterable
              clearable
              @on-clear="valueClear(1)">
        <!-- <Option value="0">System Auto</Option> -->
        <Option v-for="item in warehousesAll"
                :value="item.attach.code"
                :key="item.key">{{item.label}}</Option>
      </Select>
    </FormItem>
    <FormItem style="width:90%"
              :label="$t('erp.b2c.shipping_method',{defaultValue:'发货方式'})"
              prop="carrierServiceCode">
      <Select v-model="formData.carrierServiceCode"
              :placeholder="$t('erp.b2c.orgWarehouse_null',{defaultValue:'不选时不做处理'})"
              filterable
              clearable
              ref="refshipping"
              @on-change="validIsNull"
              @on-clear="valueClear(2)">
        <!-- <Option value="AUTO">System Auto</Option> -->
        <Option v-for="item in sysshippingcode"
                :value="item.value"
                :key="item.value">{{item.label}}</Option>
      </Select>
    </FormItem>
    <FormItem style="width:90%"
              :label="$t('global.common.notes',{defaultValue:'备注'})">
      <Input v-model="formData.remark"
             :rows="3"
             type="textarea" />
    </FormItem>
    <footer class="text-right">
      <Button type="primary"
              @click="submit">{{$t('global.common.save',{defaultValue:'保存'})}}</Button>
      <Button class="margin-left-10"
              @click="cancel">{{$t('global.common.operation_cancel',{defaultValue:'取消'})}}</Button>
    </footer>
    <Spin size="large"
          fix
          v-if="loading"></Spin>
  </Form>
</template>
<script>
import { HttpBatchChangeWarehouse } from '@/service/boss/distribution'
import { HttpGetAllCustomerIdCode} from '@/service/boss/b2corder'

import { mapState, mapGetters } from 'vuex'
export default {
  props: ['activeids'],
  data () {
    return {
      warehouseList: [],
      formData: {
        orgWarehouseCode: '',
        carrierServiceCode: '',
        remark: "",
      },
      sysshippingcode:[],
      // warehouseId:'',
      shippingList: [],
      loading: false,
      required: [{
        required: true,
        message: this.$t("global.common.fill_requiredd", { defaultValue: '该信息不能为空,请填写' })
      }],
    }
  },
  created(){
      this.getShipping()
  },
  computed: {
    ...mapGetters('dictionary', ['getNewAllWarehouseIdList']),
    // ...mapState("boss", ["sysshippingcode"]),
    warehousesAll () {
      let existCode = [];
      let arr = [];
      this.getNewAllWarehouseIdList.map((item) => {
        if (existCode.indexOf(item.attach.code) < 0) {
          existCode.push(item.attach.code);
          // console.log(existCode)
          arr.push(item);
        }
      });
      // console.log(arr)
      return arr;
    },
  },
  methods: {
      getShipping(){
          HttpGetAllCustomerIdCode().then(res => {
            let dataArr = res.data.map(item => {
            return {
                label: `${item.code}(${item.carrierServiceName})`,
                value: item.code,
                attach: {
                ...item
                }
            }
            })
            this.sysshippingcode = dataArr
            // this.sysshippingcode = concatArr.concat(this.sysshippingcode.concat(aaa))
            // this.sysshippingcode = this.arrayUnique(this.sysshippingcode,'value')
            // console.log(res)
        }, err => {
            this.$VMessage.error({
            content: err.message,
            duration: 30,
            closable: true
            });
        })
      },
    valueClear (flag) {
      switch (flag) {
        case 1:
          this.formData.orgWarehouseCode = ''
          break
        case 2:
          this.formData.carrierServiceCode = ''
          break
      }
    },
    validIsNull () {
      if (!this.formData.carrierServiceCode && (this.formData.orgWarehouseCode === '' || this.formData.orgWarehouseCode === undefined)) {
        this.$Message.error('发货仓库和发货方式不可以同时为空');
        return false
      }
      else {
        return true
      }
    },
    cancel () {
      this.$emit('on-close')
    },
    async submit () {
      let valid = await this.$refs['form'].validate();
      if (!valid) return;
      if (!this.validIsNull()) {
        return
      }
      let requestData = {
        deliverOrderIds: this.activeids,
        remark: this.formData.remark,
        carrierServiceCode: this.formData.carrierServiceCode,
        orgWarehouseCode: this.formData.orgWarehouseCode
      }
      this.loading = true;
      HttpBatchChangeWarehouse(requestData).then(res => {
        this.cancel();
        this.$emit('on-update');
      }, err => {
        this.$VMessage.error({
          content: err.message,
          duration: 30,
          closable: true
        });
      }).finally(() => {
        this.loading = false;
      })
    }
  }
}
</script>

